import React from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatcher } from 'hooks/useAppDispatcher';

export const useRouterProcess = () => {
  const location = useLocation();

  const dispatch = useAppDispatcher();

  React.useLayoutEffect(() => {
    dispatch({
      name: 'Router__PathnameChanged',
      pathname: location.pathname,
    });
  }, [dispatch, location.pathname]);
};
